import { render } from "./FreeTrialView.vue?vue&type=template&id=65ffa9b9&scoped=true"
import script from "./FreeTrialView.vue?vue&type=script&lang=js"
export * from "./FreeTrialView.vue?vue&type=script&lang=js"

import "./FreeTrialView.vue?vue&type=style&index=0&id=65ffa9b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ffa9b9"]])

export default __exports__